export default __webpack_public_path__ + "static/media/man-user2.b876dc5c.svg";